export function capitalize(str: string) {
  const splittedValues = str.toLowerCase().split(" ");

  const transformedValues = splittedValues.map(
    (item) => item.charAt(0).toUpperCase() + item.substring(1)
  );

  return transformedValues.join(" ");
}
